import {Alert, Breadcrumb, Button} from "antd";
import {DashboardWrapper} from "../../../../layouts/dashboard-wrapper";
import {StyledPageWrapper} from "../../../../styles/dashboard/calls/calls";
import {Link} from "react-router-dom";
import {CreateDiscountForm} from "../../../../components/discounts/discount-form/create";
import {CreateDiscountCodeFormPageV2} from "../../../../discounts/useCases/create-discount-code/discount-code-form-page-v2";
import {ErrorBoundary} from "react-error-boundary";

export function CreateDiscountCodePage() {
  return (
    <DashboardWrapper pageTitle="Create new discount">
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/discounts">Discounts</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Create new discount</Breadcrumb.Item>
      </Breadcrumb>
      <StyledPageWrapper>
        <div className="main-area">
          {/* <CreateDiscountForm /> */}
          <ErrorBoundary
            FallbackComponent={({error, resetErrorBoundary}) => (
              <div>
                <Alert
                  message="Sorry, something went wrong."
                  showIcon
                  description={error.message}
                  type="error"
                  action={
                    <Button
                      onClick={() => {
                        resetErrorBoundary();
                      }}
                      size="small"
                      danger
                    >
                      Reset
                    </Button>
                  }
                />
              </div>
            )}
          >
            <CreateDiscountCodeFormPageV2 />
          </ErrorBoundary>
        </div>
        <div className="widget-area"></div>
      </StyledPageWrapper>
    </DashboardWrapper>
  );
}
